import { AUTH_SET_TOKEN, AuthAction } from 'actions/auth/AuthActionsTypes';

export const setAuthToken = (token: string): AuthAction => {
    return {
        type: AUTH_SET_TOKEN,
        payload: {
            token
        }
    };
};
